export default "__VITE_ASSET__CBwJi$ih__"